import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useToast } from "@/components/ui/use-toast";
import Layout from '@/components/Layout';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import OrganizationStep from '@/components/OnboardingSteps/OrganizationStep';
import InviteStep from '@/components/OnboardingSteps/InviteStep';

const CreateOrganization = () => {
  const navigate = useNavigate();
  const { axiosInstance } = useAuth();
  const { toast } = useToast();
  const [step, setStep] = useState(1);
  const [orgData, setOrgData] = useState({});
  const [inviteData, setInviteData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleCreateOrganization = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post('/organizations/onboarding', {
        orgName: orgData.name,
        orgSlug: orgData.slug,
        inviteTeamEmails: inviteData.teamEmails?.split(',').map(email => email.trim()).filter(Boolean) || [],
      });

      const { organization } = response.data;

      toast({
        description: `${organization.name} created successfully!`,
        variant: "default",
      });

      navigate(`/${organization.slug}`);
    } catch (error) {
      console.error('Error:', error);
      toast({
        description: "Failed to create organization",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (step === 1 && (!orgData.name || !orgData.slug)) {
      toast({
        description: "Please fill in all required fields",
        variant: "destructive",
      });
      return;
    }
    setStep(2);
  };

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <Card>
          <CardContent className="p-6">
            {step === 1 && (
              <>
                <OrganizationStep
                  stepKey="organization"
                  updateStepData={(_, data) => setOrgData(data)}
                  getStepData={() => orgData}
                />
                <div className="mt-6 flex justify-end">
                  <Button onClick={handleNext}>Next</Button>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <InviteStep
                  stepKey="invite"
                  updateStepData={(_, data) => setInviteData(data)}
                  getStepData={() => inviteData}
                />
                <div className="mt-6 flex justify-between">
                  <Button variant="outline" onClick={() => setStep(1)}>
                    Back
                  </Button>
                  <Button onClick={handleCreateOrganization} disabled={loading}>
                    {loading ? "Creating..." : "Create Organization"}
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default CreateOrganization; 